module.exports = __webpack_public_path__ + "ea82618438fcc6cb89e6f19eb8aec6ac.png";